var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m304 96h80v-96h-80c-61.757 0-112 50.243-112 112v48h-64v96h64v256h96v-256h80l16-96h-96v-48c0-8.673 7.327-16 16-16z"}));
}

Facebook.defaultProps = {"height":"512","viewBox":"0 0 512 512","width":"512"};

module.exports = Facebook;

Facebook.default = Facebook;
